const mutations = {
  SET_MODALIDAD(state, data) {
    state.modalidad_data = data;
  },
};

export default mutations;
